export default __webpack_public_path__ + "static/media/euroIcon.f394268b.svg";